export type TNativeAudioWorkletNode = AudioWorkletNode;
